import { I18n } from '@ies/starling_intl';
import React from 'react';

import { searchPermissions } from '@/components/data';
import { MenuItem, HelpInfo } from './AppHeader';

const accessibleRoutes = [
  '/goto',
  '/redirect',
  '/my-project',
  '/login',
  '/project-detail',
  '/privilegeManagement/addPrivilegeManagement',
  '/new-project',
  '/signout',
  '/apply-mail',
  '/role-permissions-apply',
  '/testManagement/wrapManage',
];

/** 导航栏商店推荐是否展示 */
export const handleAppstoreIsShow = (
  userType: number,
  id: number,
  isAppStoreRecommend: boolean,
) => {
  if (userType !== 0 && userType !== 5) {
    return (
      <MenuItem $active={isAppStoreRecommend} to={`/${id}/recommend/`}>
        {I18n.t('store_management', {}, '商店管理')}
      </MenuItem>
    );
  } else {
    return null;
  }
};

/** 总览是否展示 */
export const handleOverviewIsShow = (
  userType: number,
  isShowProgress: boolean,
) => {
  if ((userType !== 0 && userType !== 4 && userType !== 5) || isShowProgress) {
    return true;
  } else {
    return false;
  }
};

/** 帮助和反馈是否展示 */
export const handleHelpInfoIsShow = (userType: number) => {
  if (userType !== 0 && userType !== 5) {
    return <HelpInfo />;
  } else {
    return null;
  }
};

/** 判断海外用户是否能够访问当前路由、判断当前用户是否具有访问项目的权限
 *  1.海外用户userType为5，只能访问固定的几个页面
 *  2.路由变化是查询是否具有项目阅读权限，若无跳转至权限申请页面
 */
export const handleAccessibleRoutes = (
  userType: number,
  route: string,
  id: number,
) => {
  let flag = true;
  for (const item of accessibleRoutes) {
    if (route.includes(item)) {
      flag = false;
    }
  }
  if (flag && userType === 5) {
    window.location.href = `${window.location.origin}/my-project`;
  } else if (!route.includes('role-permissions-apply') && id !== 0) {
    if (!window.location.href.includes('/issues/process/')) {
      searchPermissions('right_project_info_read', id);
    }
  }
};
